/* eslint-disable-next-line */
export const exists = (value?: any) => {
  return value !== undefined && value !== null;
};
